/**
 * The Irish NFQ, and which Bloom's levels each NFQ level emphasises.
 * @module taxonomy/nfq-alignment
 */

import { BLOOMS_TAXONOMY } from "./blooms";
import type { Alignment, QualificationFramework } from "./types";

export const NFQ_FRAMEWORK: QualificationFramework = {
  id: "nfq-ie",
  name: "National Framework of Qualifications (Ireland)",
  shortName: "NFQ",
  citation:
    "Quality and Qualifications Ireland (QQI), National Framework of Qualifications, https://www.qqi.ie/what-we-do/the-qualifications-system/national-framework-of-qualifications",
  levels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((level) => ({ level })),
};

export const NFQ_BLOOMS_ALIGNMENT: Alignment = {
  frameworkId: NFQ_FRAMEWORK.id,
  taxonomyId: BLOOMS_TAXONOMY.id,
  emphasis: {
    1: {
      primary: ["remember"],
      secondary: ["understand"],
      summary:
        "Prioritise basic recall and recognition of core facts and terms (Remember), with simple explanation.",
    },
    2: {
      primary: ["remember", "understand"],
      secondary: ["apply"],
      summary:
        "Build understanding of key concepts with straightforward explanation and classification tasks.",
    },
    3: {
      primary: ["understand", "apply"],
      secondary: ["remember"],
      summary:
        "Emphasise understanding and practical application in structured, familiar contexts.",
    },
    4: {
      primary: ["understand", "apply"],
      secondary: ["analyse"],
      summary:
        "Strengthen application and analysis in routine but varied contexts, with clear evidence of method.",
    },
    5: {
      primary: ["apply", "analyse"],
      secondary: ["understand", "evaluate"],
      summary:
        "Balance application and analysis, with justified choices and emerging evaluative judgement.",
    },
    6: {
      primary: ["remember", "understand", "apply"],
      secondary: ["analyse"],
      summary:
        "Emphasise foundational knowledge and applied skills (Remember / Understand / Apply) with some Analysis.",
    },
    7: {
      primary: ["apply", "analyse"],
      secondary: ["understand", "evaluate"],
      summary:
        "Balance Application and Analysis. Demonstrate problem-solving and growing autonomy.",
    },
    8: {
      primary: ["analyse", "evaluate"],
      secondary: ["apply", "create"],
      summary:
        "Go beyond application into critical Analysis and Evaluation, with some Creation and Design.",
    },
    9: {
      primary: ["evaluate", "create"],
      secondary: ["analyse"],
      summary:
        "Focus on Evaluation and Creation, with a research focus. Learners should bring ideas together and make an original contribution.",
    },
    10: {
      primary: ["create"],
      secondary: ["evaluate"],
      summary:
        "Focus on Creation, including original research, leadership and work that advances the field.",
    },
  },
};
